import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { callAPI } from "../feature/APISlice";
import { openForm } from "../feature/formSlice";
import AdminNavbar from "./AdminNavbar";
import CoreServicesForm from "../Form/CoreServicesForm.js";

const BASE_URL = `${process.env.REACT_APP_PRODUCTION_API_URL}backend/api/admin/core-services`;

export default function CoreServicesList() {
  const dispatch = useDispatch();
  const { items, loading, error } = useSelector((s) => s.api);

  useEffect(() => {
    dispatch(callAPI({ method: "get", url: BASE_URL }));
  }, [dispatch]);

  return (
    <div>
      <AdminNavbar />

      <div className="customcontainer">
        <button
          className="admin-btn outline"
          onClick={() => dispatch(openForm(null))}
        >
          + Add Core Service
        </button>

        {loading && <p>Loading...</p>}
        {error && <p className="error-text">{error}</p>}

        <div className="admin-card-grid">
          {items.map((s) => (
            <div className="admin-card" key={s.id}>
              <h4 className="admin-card-title">{s.title}</h4>

              <p>Status: {s.is_active ? " Active" : "❌ Inactive"}</p>

              <div className="admin-card-info">
                <p>Created By: <strong>{s.createdByName || "—"}</strong></p>
                <p>Updated By: <strong>{s.lastModifiedByName || "—"}</strong></p>
              </div>

              <div className="admin-card-actions">
                <button onClick={() => dispatch(openForm(s.id))}>✏️</button>
                <button
                  onClick={() =>
                    window.confirm("Delete?") &&
                    dispatch(
                      callAPI({
                        method: "delete",
                        url: `${BASE_URL}/${s.id}`,
                        data: { id: s.id },
                      })
                    )
                  }
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <CoreServicesForm />
    </div>
  );
}
